import { DefaultTheme } from 'styled-components';

import { exportModalDarkTheme } from '../app/components/export-modal';
import { uploadInstructionsDarkTheme } from '../app/components/upload-instructions-modal';

import { alertBoardConfigTheme } from './component-themes/alert-board-config-theme';
import { alertBoardFilterTheme } from './component-themes/alert-board-filter-theme';
import { alertBoardTheme } from './component-themes/alert-board-theme';
import { alertPreviewTheme } from './component-themes/alert-preview-theme';
import { alertDarkTheme } from './component-themes/alert-theme';
import { alertTicketDetailTheme } from './component-themes/alert-ticket-detail-theme';
import { annotationTheme } from './component-themes/annotation-theme';
import { assessVisualizerTheme } from './component-themes/assess-visualizer-theme';
import bulkActionsTheme from './component-themes/bulk-actions-theme';
import { chartDarkTheme } from './component-themes/chart-theme';
import { checkboxDarkTheme } from './component-themes/checkbox-theme';
import { confirmEmailDarkTheme } from './component-themes/confirm-email';
import { customTableTheme } from './component-themes/custom-table-theme';
import { datePickerDarkTheme } from './component-themes/date-picker-theme';
import { dateTimeRangePickerDarkTheme } from './component-themes/date-time-range-picker-theme';
import { deleteDataModalDarkTheme } from './component-themes/delete-data-modal-theme';
import { ensembleTheme } from './component-themes/ensembled-theme';
import { fileUploadModalDarkTheme } from './component-themes/file-upload-theme';
import { folderTreeV2Theme } from './component-themes/folder-tree-v2-theme';
import { headerV2Dark } from './component-themes/header-theme';
import { headerDarkThemeSystem } from './component-themes/header-theme-system';
import { headerDarkThemeTag } from './component-themes/header-theme-tag';
import { heatmapDarkTheme } from './component-themes/heatmap-theme';
import { investigateDarkTheme } from './component-themes/investigate-theme';
import { knobDarkTheme } from './component-themes/knob-theme';
import { limitDarkTheme } from './component-themes/limit-theme';
import { managePageTheme } from './component-themes/manage-theme';
import { modalDarkTheme } from './component-themes/modal-theme';
import { modelAlertsTheme } from './component-themes/model-alerts-theme';
import { modelManagerTheme } from './component-themes/model-manager-theme';
import { modelVisualizerTheme } from './component-themes/model-visualizer-theme';
import { radioButtonDarkTheme } from './component-themes/radio-button-theme';
import { scrollBarDarkTheme } from './component-themes/scrollbar-theme';
import { searchDarkTheme } from './component-themes/search-theme';
import { sidebarDarkTheme, sidebarV2Dark } from './component-themes/sidebar-theme';
import { sliderDarkTheme } from './component-themes/slider-theme';
import { switchDarkTheme } from './component-themes/switch-theme';
import { systemBrowserDarkTheme } from './component-themes/system-browser-theme';
import { tabTheme } from './component-themes/tab-theme';
import { tenantSelectorTheme } from './component-themes/tenant-selector';
import { textInputDarkTheme } from './component-themes/text-input-theme';
import { timeDisplayDarkTheme, timeDisplayDarkThemeV2 } from './component-themes/timedisplay-theme';
import { timelineDarkTheme } from './component-themes/timeline-theme';
import { timeSearchDarkTheme } from './component-themes/timesearch-theme';
import { tooltipDarkTheme } from './component-themes/tooltip-theme';
import { userPreferencesDarkTheme } from './component-themes/user-preferences-theme';
import { viewControlsTheme } from './component-themes/view-controls-theme';

import {
  buttonDarkTheme,
  dropdownDarkTheme,
  resizablePanelDarkTheme,
  selectDarkTheme,
} from '@controlrooms/components';
import { iconDarkTheme } from '@controlrooms/components';
import { datePickerTheme as datePickerV2Theme } from '@controlrooms/components/src/date-picker-v2/date-picker-theme';
import { dataTableTheme } from '@controlrooms/components/src/table/table-theme';
import { colors } from '@controlrooms/design-tokens';

export const darkTheme: DefaultTheme = {
  name: 'Dark',
  v2: {
    header: headerV2Dark,
    sidebar: sidebarV2Dark,
    timeDisplay: timeDisplayDarkThemeV2,
    tab: tabTheme.dark,
  },
  backgroundColor: colors.k[0],
  reportFilterbackgroundColor: colors.k[8],
  textColor: colors.k[100],
  linkColor: colors.focus.dark[2],
  navigation: {
    textColor: colors.k[40],
    borderColor: colors.k[30],
    active: {
      textColor: colors.k[90],
      borderColor: colors.k[80],
    },
  },
  button: buttonDarkTheme,
  sidebar: sidebarDarkTheme,
  chart: chartDarkTheme,
  checkbox: checkboxDarkTheme,
  datePicker: datePickerDarkTheme,
  dateTimeRangePicker: dateTimeRangePickerDarkTheme,
  deleteDataModal: deleteDataModalDarkTheme,
  exportModal: exportModalDarkTheme,
  tooltip: tooltipDarkTheme,
  heatmap: heatmapDarkTheme,
  modal: modalDarkTheme,
  uploadInstructions: uploadInstructionsDarkTheme,
  fileUploadModal: fileUploadModalDarkTheme,
  radioButton: radioButtonDarkTheme,
  select: selectDarkTheme,
  timeDisplay: timeDisplayDarkTheme,
  systemHeader: headerDarkThemeSystem,
  tagHeader: headerDarkThemeTag,
  switch: switchDarkTheme,
  systemBrowser: systemBrowserDarkTheme,
  scrollBar: scrollBarDarkTheme,
  search: searchDarkTheme,
  textInput: textInputDarkTheme,
  confirmEmail: confirmEmailDarkTheme,
  userPreferences: userPreferencesDarkTheme,
  timeLine: timelineDarkTheme,
  slider: sliderDarkTheme,
  alert: alertDarkTheme,
  timeSearch: timeSearchDarkTheme,
  limit: limitDarkTheme,
  knob: knobDarkTheme,
  investigate: investigateDarkTheme,
  folderTreeV2: folderTreeV2Theme.dark,
  resizablePanel: resizablePanelDarkTheme,
  tenantSelector: tenantSelectorTheme.dark,
  managePage: managePageTheme.dark,
  modelAlerts: modelAlertsTheme.dark,
  modelManager: modelManagerTheme.dark,
  modelVisualizer: modelVisualizerTheme.dark,
  alertTicketDetail: alertTicketDetailTheme.dark,
  datePickerv2: datePickerV2Theme.dark,
  viewControls: viewControlsTheme.dark,
  assessVisualizer: assessVisualizerTheme.dark,
  ensemble: ensembleTheme.dark,
  alertBoard: alertBoardTheme.dark,
  alertBoardConfig: alertBoardConfigTheme.dark,
  alertBoardFilter: alertBoardFilterTheme.dark,
  alertPreview: alertPreviewTheme.dark,
  bulkActions: bulkActionsTheme.dark,
  customTable: customTableTheme.dark,
  dataTable: dataTableTheme.dark,
  dropdown: dropdownDarkTheme,
  annotation: annotationTheme.dark,
  icon: iconDarkTheme,
};
